import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { redirectAfterCompanyAuth } from "../utils/onboardingRedirect";

export default function MagicLinkVerify() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { verifyMagicLink } = useAuth();
    const [authError, setAuthError] = useState("");

    useEffect(() => {
        const token = params.get("token");
        const email = params.get("email");
        const company = params.get("company") || "";

        if (!token || !email) {
            navigate("/login", { replace: true });
            return;
        }

        verifyMagicLink(token, email, company)
            .then(async () => {
                const jwt = localStorage.getItem("hirrd_token");
                await redirectAfterCompanyAuth(jwt, navigate);
            })
            .catch((err) => {
                const msg = err?.message || "Invalid or expired magic link.";
                setAuthError(msg);
            });
    }, [params, verifyMagicLink, navigate]);

    if (authError) {
        return (
            <div className="containerX pt-24 text-center">
                <div className="inline-block bg-red-50 border border-red-200 text-red-700 rounded-2xl px-8 py-6 max-w-sm">
                    <div className="font-semibold mb-2">Authentication failed</div>
                    <div className="text-sm mb-4">{authError}</div>
                    <button
                        onClick={() => navigate("/login")}
                        className="btn btnPrimary justify-center mx-auto text-sm"
                    >
                        Back to login
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="containerX pt-24 text-center">
            <div className="text-slate-400">Verifying your magic link...</div>
        </div>
    );
}
